import Regimens from '../../../../components/Regimens'
import { PhysicalRegimensProps } from '../utils/types'

export const PhysicalRegimens = ({ lists }: PhysicalRegimensProps) => {
  return (
    <Regimens
      recordLabel='Physical Strategy'
      durationEnabled
      frequencyEnabled
      lists={lists}
    />
  )
}
